import { render, staticRenderFns } from "./HotSpotPic.vue?vue&type=template&id=bd953156&scoped=true&"
import script from "./HotSpotPic.vue?vue&type=script&lang=js&"
export * from "./HotSpotPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd953156",
  null
  
)

export default component.exports